module.exports = __webpack_public_path__ + "img/logo.bb5b8d80.png";